import { useEffect, useId, useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import "./AttendanceQrDialog.css";

export default function AttendanceQrDialog({
  courseTitle,
  attendanceToken,
  registrationId,
  onClose,
}) {
  const titleId = useId();
  const closeBtnRef = useRef(null);

  useEffect(() => {
    if (!attendanceToken) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeBtnRef.current?.focus();

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose?.();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [attendanceToken, onClose]);

  if (!attendanceToken) return null;

  return (
    <div
      className="attendance-qr-overlay"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="attendance-qr-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <header className="attendance-qr-dialog__header">
          <div className="attendance-qr-dialog__header-text">
            <p className="attendance-qr-dialog__eyebrow">Class attendance</p>
            <h2 id={titleId} className="attendance-qr-dialog__title">
              {courseTitle}
            </h2>
          </div>
          <button
            ref={closeBtnRef}
            type="button"
            className="attendance-qr-dialog__close"
            onClick={onClose}
            aria-label="Close attendance QR"
          >
            ×
          </button>
        </header>

        <div className="attendance-qr-dialog__body">
          <div className="attendance-qr-dialog__card">
            <div className="attendance-qr-dialog__code">
              <QRCodeSVG
                value={String(attendanceToken)}
                size={220}
                level="M"
                includeMargin={false}
              />
            </div>
            <p className="attendance-qr-dialog__course-label">{courseTitle}</p>
            {registrationId != null ? (
              <p className="attendance-qr-dialog__meta">
                Registration ID #{registrationId}
              </p>
            ) : null}
          </div>

          <div className="attendance-qr-dialog__actions">
            <button
              type="button"
              className="attendance-qr-dialog__done"
              onClick={onClose}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
